import { Button, Card, CustomModalLayout, MarketingLayout, Modal } from "@wix/design-system";
import axios from "axios";
import React from "react";

type CardModalParams = {
  setModalShow: (data: boolean) => void;
  modalShown: boolean;
  title: string;
  description: string;
  siteId: string;
};

const CardModal = ({ setModalShow, modalShown, title, description, siteId }: CardModalParams) => {
  // Update Review Status
  const reviewCollect = (siteId: any, review: any) => {
    axios
      .patch("api/sites/review-status", {
        siteId: siteId,
        review_collected: review,
      })
      .then((response) => {})
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <Modal isOpen={modalShown} onRequestClose={() => setModalShow(false)} screen="desktop">
      <CustomModalLayout
        width="720px"
        removeContentPadding
        onCloseButtonClick={undefined}
        primaryButtonText="Give Review"
        primaryButtonOnClick={() => {
          let url = `https://www.wix.com/app-market/add-review/${siteId}`;

          reviewCollect(siteId, true);
          window.open(url, "_blank");
          setModalShow(false);
          window.location.reload();
        }}
        content={
          <Card>
            <MarketingLayout size="medium" title={title} description={description} />
          </Card>
        }
      />
    </Modal>
  );
};

export default CardModal;
